<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a
              href="https://www.frozenmountain.com/about/about-us"
              target="_blank"
            >
              About Us
            </a>
          </li>
          <li>
            <a :href="helpLink.documentationBase" target="_blank">
              {{ environment === "beta" ? "Beta " : "" }}Documentation
            </a>
          </li>
          <li>
            <a href="https://support.liveswitch.io/" target="_blank">
              Support
            </a>
          </li>
          <li>
            <a href="http://status.liveswitch.io/" target="_blank">
              Status
            </a>
          </li>
          <li>
            <a href="https://github.com/liveswitch" target="_blank">
              Tools
            </a>
          </li>
        </ul>
      </nav>
      <div id="copyright" class="text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.frozenmountain.com/" target="_blank">
          Frozen Mountain Software Ltd., </a
        ><span id="version">Version {{ buildVersion }}</span>
      </div>
    </div>
  </footer>
</template>
<script>
import VersionConfig from "@/../version.json";
import api from "@/api";
import helpLinks from "@/contextualHelpLinks.js";
export default {
  data: () => ({
    buildVersion: VersionConfig["liveswitch-cloud-console"],
    environment: api.props.config.environment,
    helpLink: helpLinks,
  })
};
</script>
<style lang="scss" scoped>
#version {
  font-size: 0.85em;
  color: #666;
}
</style>
